module.exports = __webpack_public_path__ + "media/images/app-night-7e27fe5a38214cc2d05b276b941311ba.png";